<ng-content></ng-content>
<span>{{currentIndex + 1}} / {{sliderViews.length}}</span>